

const form = {
    year: "Year",
    invoiceStatus: "Invoice Status",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    status: "Status",
    password: "Password",
    confirmPassword: "Confirm Password",
    dateOfEntry: "Date Of Entry",
    dateOfExit: "Date Of Exit",
    city: "City",
    voucherType: "Voucher type",
    sortBy: "Sort by",
    contactPerson: "Contact Person",
    salutation: "Salutation",
    measures: "Measures",
    intermediary: "Intermediary (Internal)",
    lecturer: "Lecturer",
    preview: "Preview",
    sendReminder: "Send Reminder",
    loading: "Loading.....",
    invalidLink: "Invalid Link",
    invalidLinkMessage: "The link you have clicked is invalid or has expired.",
    pleaseFillAllTheFields: "Please fill all the fields",
    pleaseSignTheForm: "Please sign the form",
    // Authority
    authority: "Authority",
    bgNumber: "BG-Number",
    team: "Team",
    contactPerson: "Contact Person",
    routingId: "Routing ID (for e-invoicing)",
    contactEmail: "Contact E-mail",
    contactTel: "Contact Tel",
    authorityStreet: "Authority Street and house number",
    authorityPostalCode: "Authority Postal Code",
    authorityCity: "Authority City",
    measure: "Measure",
    intermediary: "Intermediary",
    reports: "Reports",

    required: "This field is required",
    invalidEmail: "Please enter a valid email address",
    error: "Error",
    success: "Success",

    settings: "Settings",
    permissionToSignRetroactively: "Permission to sign retroactively",
    receiveTeachingMaterials: "Receive teaching materials",
    faceToFaceInstruction: "Face-to-face instruction",
    onlineInstruction: "Online instruction",
    informationForSuccessAndPlacementStatistics: "Information for success and placement statistics",
    surveyedAfter6Months: "Surveyed after 6 months",
    mediated: "Mediated",
    saveDetails: "Save Details",

    street: "Street",
    streetName: "Street Name",
    streetNo: "Street No.",
    country: "Country",
    pincode: "Pincode",
    userId: "User ID",

    examinations: "Examinations",
    reportsToTheInsuranceProvider: "Reports to the insurance provider",
    feedbackForm: "Feedback form",
    theParticipantHasNotYetAnsweredAnyFeedbackQuestions: "The participant has not yet answered any feedback questions!",
    createADischargeReport: "Create a discharge report",
    dischargeReport: "Discharge report",
    createATerminationReport: "Create a termination report",
    terminationReport: "Termination report",
    generatedMessages: "Generated messages",
    date: "Date",
    description: "Description",
    sentTo: "Sent to",
    sentOn: "Sent on",
    edit: "Edit",
    examsFrom: "Exams from",
    examsTo: "Exams to",
    examType: "Exam Type",
    registerForExam: "Register for exam",
    differentInvoiceRecipient: "Different Invoice Recipient",
    ifYouWouldLikeToEnterADifferentInvoiceRecipient: "If you would like to enter a different invoice recipient, please fill out the following fields. When creating the invoice or reminder, the entries in the \"Different invoice recipient\" fields will overwrite the \"Cost object\" fields.",
    bahrodeCompany: "Bahrode / Company",
    contactPerson: "Contact Person",
    routingId: "Routing ID (for e-invoicing)",
    invoice: "Invoice",
    cancelInvoice: "Cancel Invoice",
    billingEmail: "Billing email address",
    streetAndHouseNumber: "Street and house number",
    postalCode: "Postal code",
    registeredExamDates: "Registered Exam Dates",
    markAsBilled: "Mark as Billed",
    whenWasTheCourseWrittenIHKProfessionalKnowledgeAccordingTo34aTradeRegulationBilled: 'When was the course: {{courseName}} billed?',
    examinationFromTo: "Examination From - to",
    typeOfExam: "Type of exam",
    examinationResult: "Examination result",
    certificate: "Certificate",
    billedOn: "Billed on",

    houseNumber: "House number",
    placeOfBirth: "Place of Birth",
    phoneNumber: "Phone Number",
    countryOfbirth: "Country of Birth",
    email: "E-mail",
    birthDate: "Birth Date",
    remarks: "Remarks",

    createAttendanceList: "Create attendance list",
    dateFrom: "Date From",
    dateUntil: "Date Until",
    createACertificateOfAbsenceForTheJobCenter: "Create a certificate of absence for the JobCenter",
    createPDF: "Create PDF",
    missingSignatures: "Missing signatures",
    allSignaturesAreThere: "All signatures are there!",
    updatedOn: "Updated on",
    updateAttendance: "Update attendance",
    missingSignaturesForDays: "Missing signatures for {{count}} day(s):",
    missingSignaturesForDaysText: "Missing signatures for",
    markDateAsPresent: "Do you want to mark the date {{date}} as present?",
    yesMarkPresent: "Yes, mark as present",
    reasonsForAbsence: "Reasons for absence",
    certificateFor: "Certificate for",
    dayOfAbsenceFrom: "Day of absence from",
    dayOfAbsenceUntil: "Day of absence until",
    reason: "Reason",
    noEntriesFound: "No entries found",
    aMaximumOfFourReasonsForAbsenceCanBeEnteredOnBehalfOfTheParticipantInTheSGBFbWCertificateOfAbsenceDocument: 'A maximum of four reasons for absence can be entered on behalf of the participant in the SGB ||| - FbW Certificate of Absence document in the field "To be completed by the participant:" -> "Statement on absences:"!',
    justifyAbsence: "Justify absence",
    certificatesOfAbsenceIssued: "Certificates of absence issued",
    fileToDownload: "File to download",
    edit: "Edit",
    createdAttendancePDFs: "Created attendance PDFs",
    presenceOf: "Presence of",
    presenceUntil: "Presence until",

    insertSickNoteOrDayOfAbsence: "Insert sick note or day of absence",
    reasonForSickLeaveOrAbsence: "Reason for sick leave or absence",
    reasonsForSickLeaveOrDaysOfAbsenceAreTransferredToTheDocument: "Reasons for sick leave or days of absence are transferred to the document S.GB ||| - Fbw Certificate of Absence in the field Absences -> Reason!",

    createEInvoices: "Create e-invoices",
    invoiceNumber: "Invoice Number",
    invoiceDate: "Invoice date",
    invoiceAmountInEUR: "Invoice Amount in EUR",
    invoiceType: "Invoice type",
    createInvoices: "Create invoices",
    rgNumber: "Rg-Number",
    rgDate: "Rg-Date",
    rgSum: "Rg-sum",
    reminder: "Reminder",
    reminderAutodispatch: "Reminder-Autodispatch",
    paid: "Paid",
    paidOn: "Paid on",
    unpaid: "Unpaid",
    recordID: "Record ID",
    messages: "Messages",
    mr: "Mr.",
    mrs: "Mrs.",
    drivers: "Drivers",

    eExcused: "E - Excused",
    ueUnexcused: "UE - Unexcused",
    kIllness: "K - Illness",
    sOther: "S - Other",
    PLZ: "PLZ",
    dateOfDeparture: "Date of departure",

    motherTongue: "Mother Tongue",
    verhandlungssicher: "Verhandlungssicher",
    veryGood: "Very good",
    good: "Good",

    shiftSystem: "Shift system (Day/Night/Weekend)",
    workingHours: "Working hours (8h/12h)",
    healthRestrictions: "Health restrictions",
    furniture: "Furniture (public/car)",
    miscellaneous: "Miscellaneous",
    yes: "Yes",
    no: "No",

    internetEnabledHardware: "Do you have an internet-enabled mobile phone, tablet, laptop, PC or other hardware (with a bandwidth of at least 1.5 Mbps is recommended)?",
    b1LevelIsAvailable: "B1 level is available",
    jobBoardAccessDataAvailable: "Job board access data available",
    certificateOfGoodConductWasAvailable: "Certificate of good conduct was available",
    experienceInTheSecuritySector: "Experience in the security sector",
    lastEmploymentRelationship: "Last employment relationship",
    currentEmploymentRelationship: "Current employment relationship",

    assessmentOfSuitabilityForFurtherTraining: "Assessment of suitability for further training",
    chamberOfIndustryAndCommerceCertifiedSafetySpecialist: '"Chamber of Industry and Commerce certified safety specialist according to Section 34a of the German Trade Regulation Act (GewO) online"',
    houseRules: "House Rules",
    readCarefully: "Read carefully",
    order: "Order",
    allRoomsAndFacilitiesAtOurSchoolMustBeMaintainedInOrderAndCleanliness: "All rooms and facilities at our school must be maintained in order and cleanliness. Classrooms, facilities, and equipment must be used with care. Students are not permitted to stay in classrooms outside of class hours. Sticking or writing anything on the walls in classrooms and moving school furniture to other rooms are prohibited. Staff and students who notice any damage should report it to the office.",
    alcoholAndDrugConsumption: "Alcohol and drug consumption",
    theConsumptionOfAlcohol: "The consumption of alcohol, illegal drugs, and other psychoactive substances is prohibited throughout the school grounds and during school events (including all recesses). In exceptional cases, the school administration may permit the consumption of alcohol.",
    theft: "Theft",
    theftDescription: "It is recommended that valuables and cash be carefully stored. The school provides free lockers for students and staff. A fee of €50 will be charged for lost keys. The school assumes no liability for theft.",
    parking: "Parking",
    thereAreNoFreeParkingSpacesAvailableOnTheSchoolGrounds: "There are no free parking spaces available on the school grounds. Bicycles must be locked and stored in the designated bicycle storage room. Mopeds and motorcycles are not permitted on the school grounds.",
    taskDescription: "You are reading the text and questions 1 to 4 about it. For each question, select the correct answer: a, b, or c. You are getting information about the house rules of BAD Bildungsakademie Deutschland GmbH. You are participating in a training course in their premises.",
    oneAnswerIsCorrect: "One answer is correct!",

    questionTask2_1: "What are the reactions to frustration?",
    questionTask2_2: "What signs could indicate drug use?",
    questionTask2_3: "What should be considered when interacting with groups?",
    questionTask2_4: "What is a basic human need?",
    questionTask2_5: "What behavior can one expect from intoxicated people?",
    calmness: "Calmness",
    contentment: "Contentment",
    aggression: "Aggression",
    increasedConcentration: "Increased ability to concentrate",
    socialEngagement: "Social engagement",
    dilatedPupils: "Dilated pupils, skin discoloration",
    easilyProvoked: "Easily provoked",
    formingAlliances: "Forming alliances with the group",
    behavingNeutrally: "Behaving neutrally",
    food: "Food",
    selfActualization: "Self-actualization",
    friendship: "Friendship",

    generalKnowledge: "General Knowledge",
    questionTask3_1: "How high is the VAT rate in Germany?",
    questionTask3_2: "What jobs can you pursue with the expert knowledge test according to Section 34a of the Trade Regulation Act (GewO)?",
    questionTask3_3: "Who is responsible for compliance with the law in Germany?",
    questionTask3_4: "How many federal states does Germany have?",
    questionTask3_5: "What is the name of the current Chancellor of Germany?",

    cleaner: "Cleaner",
    securityGuard: "Security guard",
    busDriver: "Bus driver",
    thePolice: "The police",
    theCourts: "The courts",
    theSecurityServices: "The security services",
    answer5: "5",
    answer16: "16",
    answer23: "23",
    msMerkel: "Ms. Merkel",
    mrAdenauer: "Mr. Adenauer",
    mrScholz: "Mr. Scholz",
    hamburg: "Hamburg",
    munich: "Munich",
    berlin: "Berlin",
    signature: "Signature",
    plz: "PLZ",

    ifNoThisWillBeRequestedBeforeTheStartOfTheMeasureAndSubmitted: "If no, this will be requested before the start of the measure and submitted to BAD Blidungsakademie Deutschland GmbH. After that, the measure can only begin if no relevant entries are available. I have taken note of this and confirm this.",
    applicantSignature: "Applicant's signature",
    yesHerebyConfirm: "Yes -> I hereby confirm that I am fully aware that this course is a full-time program. I am confident that I can complete it alongside my studies.",
    herebyConfirmCompleteness: "I hereby confirm the completeness and accuracy of the above information and agree that BAD Bildungsakademie Deutschland GmbH may store my personal data in its system until further notice.",

    NameOfTheClerkAndDate: "Name of the clerk and date",
    certificateOfGoodConductWasAvailable: "Certificate of good conduct was available:",
    relevantEntry: "Relevant entry",
    notRelevantEntry: "Not relevant entry",
    noEntry: "No entries",
    certificateOfGoodConductWasNotAvailable: "Certificate of good conduct was not available:",
    remarksNotesFromTheClerkDuringTheInterview: "Remarks/Notes from the clerk during the interview:",
    willBeSubmittedOn: "Will be submitted on:",
    reminderSet: "Reminder set (Outlook, mobile, other)",

    allMeasures: "All measures",
    showEvaluation: "Show evaluation",
    createdFeedbackEvaluations: "Created feedback evaluations",
    feedbackEvaluation: "Feedback evaluation",
    successAndPlacementStatistics: "Success and Placement Statistics",
    createdSuccessAndPlacementStatistics: "Created Success and Placement Statistics",
    qualificationPlanCreate: "Qualification Plan Create",
    createdQualificationPlans: "Created Qualification Plans",
    German: "German",
    English: "English",
    French: "French",
    Turkish: "Turkish",
    Arabic: "Arabic",
    Other: "Other",
    interestedInMeasure: "In which measure is the participant interested?",
    dataCollectionForm: "Data Collection Form",
    basicKnowledge: "Basic Knowledge",

    fromTime: "From time",
    toTime: "To time",
    photo: "Photo",
    duration: "Duration",
    hour: "Hour",
    to: "to",

    // Results Sheet
    carrierOfTheMeasure: "Carrier of the measure",
    nameOfTheMeasure: "Description of the measure",
    measureNumber: "Measure number",
    contactPersonInclTel: "Contact person (incl. Tel. number)",
    nameFirstName: "Name, First name",
    placeOfResidence: "Place of residence (Agency for Labour / Jobcenter)",
    orgNumber: "Org.number / Customer number",
    referenceNumber: "Reference number (Applicant profile)",
    finalInvoice: "Final Invoice",
    rate: "Rate",
    expertKnowledge: "Expert knowledge",
    advancedKnowledge: "Advanced knowledge",
    basicKnowledge: "Basic knowledge",
    willingnessToBeMobile: "Willingness to be mobile",
    acrossTheCountry: "Across the country",
    international: "international",
    maxPendelTime: "Maximum commuting time (total)",
    regionalWishes: "Regional wishes",
    from: "From",
    to: "To",
    at: "At",
    activity: "Activity as",
    applicationTo: "Application to",
    participant: "Participant",
    resultOpen: "Result Open",
    cancellation: "Cancellation",
    dateOfTheParticipant: "Date (Participant)",
    trainingSupportCreated: "Created support for vocational training result sheet",

    participantId: "Participant ID",
    attendanceInTheMorning: "Attendance in the morning",
    attendanceInTheAfternoon: "Attendance in the afternoon",

    documents: "Documents",
    fileDescription: "File - Description",
    fileUpload: "File to upload",
    uploadedFiles: "Uploaded Files",
    certificates: "Certificates",
    certificateOfTheCarrier: "Certificate of the carrier",
    generatedMessages: "Generated Messages",
    createdFeedbackForms: "Created Feedback Forms",
    createdCertificatesOfAbsences: "Created Certificates of Absences",
    certificatesOfAbsences: "Certificates of Absences",
    createdInvoices: "Created Invoices",
    createdProfessionalDevelopmentFundingRequestResultsSheet: "Created Professional Development Funding Request Results Sheet",
    trainingReportsOfTheParticipant: "Training Reports of the Participant",
    updatedOn: "Updated On",
    attendanceDate: "Attendance Date",
    willBeDisplayedFrom1300: "Will be displayed from 13:00",
    willBeDisplayedFrom0900: "Will be displayed from 09:00",
    weekend: "Weekend",
    holiday: "Holiday",
    daysUntilReminderNotice: "{{count}} days until reminder notice",
    joiningDate: "Joining Date",
    examResult: "Exam Result",
    passed: "Passed",
    failed: "Failed",
    markAsBilled: "Mark as Billed",

    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    assessment: "Assessment",
    finalAssessment: "End Assessment",
    interimAssessment: "Interim Assessment",
    dateBetweenReview: "Interim Review Date",
    participantName: "Participant Name",
    lecturer: "Instructor",
    courseDuration: "Course Duration",
    largestSuccessExperience: "Greatest Success Experience",
    personalDevelopment: "Personal Development",
    largestChallenge: "Biggest Challenge",
    oralParticipation: "Oral Participation",
    writtenPerformance: "Written Performance",
    handlingLearningProblems: "Handling Learning Difficulties",
    developmentOfWeakerSubjectAreas: "Development of Weaker Subject Areas",
    usageOfSupportServices: "Utilization of Support Services",
    overallJudgment: "Overall Assessment",
    lecturerSignature: "Lecturer's Signature",
    participantSignature: "Participant's Signature",
    learningStand: "Learning Status",
    ratingByLecturer: "Lecturer's Evaluation",
    testResults: "Test Results",
    lecturerRating: "Lecturer Rating",
    absences: "Absences",
    currentLearningProgress: "Current Learning Progress",
    isTheSuccessOfTheMeasureThreatened: "Is the Success of the Measure at Risk?",
    supportMeasuresTakenToSupportTheParticipant: "What support measures have been taken to assist/promote the participant...",
    pdfName: "PDF Name",
    documentUpload: "Document Upload",
    fileName: "File Name",
    remarks_student: "Remarks",

    addLiveWebinar: "Add Live Webinar",
    webinarLink: "Webinar Link",
    title: "Title",
    messages: "Messages",
    daysMessageAttendance: "{{count}} Absences",
    name: "Name",
}

export default {
    common: {
        totalLicenses: "Total Licenses",
        changedEndDate: "Changed End Date",
        yearlyLogs: "Yearly Logs",
        generateLogs: "Generate Logs",
        fridaySheet: "Friday Exam",
        fridaySheetTitle: "Security Knowledge 34a - Your Friday Exam",
        selectedAnswer: "Selected Answer",
        correctAnswer: "Correct Answer",
        studentAbsences: "Student Absences",
        examSheetSuccessTitle: "EXAM PASSED",
        examSheetNotPassed: "NOT PASSED",
        examSheetSuccessDescription: "Your score:",
        points: "Points",
        pass: "Passed",
        failed: "Failed",
        subjectKnowledge34aSimulation: "Subject Knowledge 34a – Simulation",
        expertiseSection34aExercisesForTheOralExamination: "Expertise §34a – Exercises for the oral examination",
        examMode: "Exam Mode",
        practiceMode: "Practice Mode (Learnmode)",
        subjectKnowledge34aPractice: "Subject Knowledge 34a – Practice for the written exam",
        examination: "Examination",
        pleaseAdd: "Please Add",
        search: "Search",
        clearAll: "Clear All",
        applyFilter: "Apply Filter",
        pleaseEnter: "Please Enter",
        pleaseSelect: "Please Select",
        addNewUser: "Add New User",
        addNewUserLessDetails: "Add Employee",
        editUser: "Edit User",
        rowsPerPage: "Rows per page",
        displaying: "Displaying {from} to {to} of {total} entries",
        previous: "Previous",
        next: "Next",
        all: "All",
        page: "Page",
        of: "of",
        goToPage: "Go to page",
        first: "First",
        last: "Last",
        active: "Active",
        inactive: "Inactive",
        send: "Send",
        updateAndRegeneratePDF: "Update and regenerate PDF",
        save: "Save",
        yes: "Yes",
        edit: "Edit",
        no: "No",
        number_no: "No.",
        back: "Back",
        update: "Update",
        cancel: "Cancel",
        delete: "Delete",
        setUpPassword: "Set Up Password",
        newPassword: "New Password",
        confirmPassword: "Confirm Password",
        saveChanges: "Save Changes",
        required: "This field is required",
        invalidEmail: "Please enter a valid email address",
        invalidPassword: "Password must be at least 8 characters long",
        confirmPasswordError: "Passwords do not match",
        noDataFound: "No data found",
        date: "Date",
        ID: "ID",
        actions: "Actions",
        participantData: "Participant data",
        contactDetails: "Contact Details",
        attendance: "Attendance",
        sickNotes: "Sick Notes/Absences",
        invoices: "Invoices",
        resultsSheet: "Results Sheet",
        learningProgress: "Learning Progress",
        documents: "Documents",
        invalid: "Please enter a valid information",
        invalidPhoneNumber: "Invalid phone number",
        areYouSureYouWantToProceed: "Are you sure you want to proceed?",
        confirmation: "Confirmation",

        task: "Task",
        tasks: "Tasks",
        students: "Students...",
        theFollowingAppliesToTheClassroomsOfBADBildungsakademieDeutschlandGmbH: "The following applies to the classrooms of BAD Bildungsakademie Deutschland GmbH:",
        toUseTheLockableLockersYouMust: "To use the lockable lockers, you must...",
        drinkingAlcohol: "Drinking alcohol...",
        areNotAllowedToBringBicyclesToSchool: "Are not allowed to bring bicycles to school.",
        areAllowedToLeaveTheirBicyclesInTheSchoolyard: "Are allowed to leave their bicycles in the schoolyard.",
        mustLeaveTheirBicyclesInASpecialRoom: "Must leave their bicycles in a special room.",
        studentsAreNotPermittedToHangPosters: "Students are not permitted to hang posters.",
        studentsMustCleanUpAfterClass: "Students must clean up after class.",
        studentsMayStudyThereAfterClass: "Students may study there after class.",
        requestAKeyFromTheOffice: "Request a key from the office.",
        payAOneTimeFeeOf50: "Pay a one-time fee of €50.",
        beAStudentOrWorkAt: "Be a student or work at the BAD Bildungsakademie Deutschland GmbH.",
        mayBeApprovedByTheSchoolAdministration: "May be approved by the school administration.",
        mustBeReportedToTheTeacher: "Must be reported to the teacher.",
        isStrictlyProhibited: "Is strictly prohibited.",
        sampleQuestionsFromAnIHKExpertKnowledgeExamination: "Sample questions from an IHK expert knowledge examination §34a according to GewO",
        messageForFileUploadLimit: "Message: The uploaded file must not exceed 5 MB, and the supported file format is PDF.",
        userInformation: "User Information",
        savePDF: "Save as PDF"
    },
    auth: {
        login: "Login",
        logout: "Logout",
        username: "Email",
        password: "Password",
        rememberMe: "Remember me",
        forgotPassword: "Forgot password?",
        welcomeMessage: "Enter your credentials and enjoy our courses",
        usernamePlaceholder: "Enter your email",
        passwordPlaceholder: "Enter your password",
        welcomeMessage1: "Very good works are",
        welcomeMessage2: "waiting for you",
        welcomeMessage3: "Login Now"
    },
    sidebar: {
        main: "MAIN",
        others: "OTHERS",
        dashboard: "Dashboard",
        users: "Users",
        participants: "Participants",
        documents: "Documents",
        attendance: "Attendance",
        settings: "Settings",
        carrier: "Carrier",
        notifications: "Notifications",
        logout: "Logout",
        students: "Students",
        measurement: "Measurement",
        intermediary: "Intermediary",
        examinations: "Examinations",
        bridgeDays: "Bridge Days",
        lecturers: "Lecturers",
        qualificationPlan: "Qualification Plan",
        documents: "Documents",
        liveAttendance: "Live Attendance",
        missingSignatures: "Missing Signatures",
        organization: "Organization",
        qualificationMatrix: "Qualification Matrix",
        trainingReports: "Training Reports",
        liveWebinar: "Live Webinar",
        studentsLogs: "Student's Logs",
        stundenplan: "Stundenplan",
    },
    stundenplan: {
        title: "Stundenplan",
        addCourseLabel: "Add new 3-month course",
        trainer: "Lecturer",
        startDate: "Start date",
        addButton: "Add course",
        addSuccess: "Course added successfully. The schedule will reload.",
        addError: "Failed to add course.",
        loadError: "Could not load lecturer list.",
    },
    header: {
        welcome: "Welcome Back",
        search: "Search Here",
        language: "Language",
        english: "English",
        german: "German"
    },
    users: {
        title: "Users",
        list: "User List",
        add: "Add New User",
        edit: "Edit User",
        delete: "Delete User",
        confirmDelete: "Are you sure you want to delete this user?",
        cancel: "Cancel",
        save: "Save",
        table: {
            id: "ID",
            name: "Name",
            email: "Email",
            address: "Address",
            status: "Status",
            action: "Action",
            userName: "User Name",
            firstName: "First Name",
            lastName: "Last Name",
            phoneNumber: "Phone Number",
            dateOfBirth: "Date of Birth",
            zipCode: "Zip Code",
            placeOfBirth: "Place of Birth",
            countryOfbirth: "Country of Birth",
            telephone: "Telephone",
            city: "City"
        },
        form: {
            userName: "User Name",
            firstName: "First Name",
            lastName: "Last Name",
            phoneNumber: "Phone Number",
            email: "Email",
            address: "Address",
            status: "Status",
            password: "Password",
            confirmPassword: "Confirm Password",
        },
        validation: {
            required: "This field is required",
            email: "Please enter a valid email address",
            password: "Password must be at least 8 characters long",
            confirmPassword: "Passwords do not match"
        }
    },
    searchFilter: {
        search: "Search Filter",
    },
    home: {
        cards: {
            totalStudents: "Total Students",
            totalTeachers: "Total Teachers",
            totalEmployee: "Total Employee",
            totalCourses: "Total Courses"
        },
        charts: {
            attendance: "Attendance Chart",
            totalStudents: "Total Students",
            activeInactiveStudents: 'Active/Inactive Students',
            activeStudents: 'Active Students',
            inactiveStudents: 'Inactive Students',
            byGender: "by Gender",
            boys: "Boys",
            girls: "Girls",
            thisWeek: "This Week",
            lastWeek: "Last Week",
            thisMonth: "This Month",
            present: "Total Present",
            absent: "Total Absent",
            sick: "Total Sick"
        }
    },
    students: {
        studentsList: "Student List",
        add: "Add New Student",
        edit: "Edit Student",
        delete: "Delete Student",
        confirmDelete: "Are you sure you want to delete this student?",
        cancel: "Cancel",
        save: "Save",
        participantData: "Participant Data"
    },
    measurement: {
        addNewMeasurement: "Add New Measurement",
        measurementList: "Measurement List",
        measurements: "Measurements",
        no: "No",
        measuresNumber: "Measures Number",
        measuresTitle: "Measures Title",
        months: "Months",
        showInDocuments: "Show in documents",
        edit: "Edit",
        accordingToParagraph: "According to paragraph",
        measureEdit: "Measure Edit",
        createNewMeasurement: "Create New Measurement",
        measure: "Measure",
        registeredForTheMeasureAre: "Registered for the measure are"
    },
    intermediary: {
        insertNewAgent: "Insert New Agent",
        intermediary: "Intermediary",
        addNewIntermediary: "Add New Intermediary",
        agentEmail: "Agent email",
        agentTel: "Agent Tel",
        eMustermannMustermann: "e.g.: Max Mustermann or Mr. Mustermann",
        intermediaryParticipant: "Intermediary Participant",
        agentsBearbetten: "Agents Bearbetten"
    },
    examinations: {
        examinations: "Examinations",
        insertNewTest: "Insert New Test",
        test: "Test",
        addNewTest: "Add New Test",
        examinationTitle: "Examination Title"
    },
    bridgeDays: {
        bridgeDays: "Bridge Days",
        addNewBridgeDay: "Add New Bridge Day",
        bridgeDayList: "Bridge Day List",
        bridgeDay: "Bridge Day",
        insertBridgeDays: "Insert Bridge Days"
    },
    documents: {
        assessmentOfSuitability: "Assessment of Suitability",
        dataCollectionForm: "Data Collection Form",
        generateLink: "Generate Link",
        generatedLink: "Generated Link",
        createNewUrlForSuitabilityAssessment: "Create new URL for Suitability Assessment",
        createNewUrlForDataEntryForm: "Create new URL for data entry form",
        YouCanEditTheRegistrationFormAtAnyTime: "You can edit the registration form at any time.",
        clickGenerateLink: 'Click the "Generate Link" button to generate a custom link that you can send to your customer.',
        clickCopy: 'Click the "Copy" button to save the link to your clipboard.',
        youCanNowSendTheLink: 'You can now send the link to your customer in any way you like, via WhatsApp or email.',
        linkIsValidFor8Days: "The link is valid for 8 days. If your customer does not complete the eligibility assessment within 8 days, this link will be deleted from the system.",
        youCanGenerateAsManyLinksAsYouLike: "You can generate as many links as you like.",
        createdUrls: "Created URLs",
        linkDate: "Link Date",
        firstName: "First name",
        lastName: "Last name",
        dateSignature: "Date, signature",
        comment: "Comment",
        aptitudeAssessmentFrom: "Aptitude assessment from",
        commentsNotes: "Comments/Notes from the educational provider",
        updateAndRegeneratePdf: "Update and regenerate PDF",
        notYetSigned: "Not yet signed! This URL will be automatically deleted in 8 days.",
        copy: "Copy",
        dataCollectionForm: "Data Collection Form",
        whichMeasureIsTheParticipantInterestedIn: "Which measure is the participant interested in?",
        specialKnowledge: "Special Knowledge",
        languages: "Languages",
        wordAndWriting: "Word and writing",
        personalSuitability: "Personal suitability",
        professionalSuitability: "Professional suitability",
        professionalInformation: "Professional information",
        assessmentOfConsultation: "Assessment of consultation (measure target achievable)",
        notesRecommendations: "Notes/Recommendations BAD Bildungsakademie Deutschland GmbH:"
    },
    lecturers: {
        lecturersList: "Lecturers List",
        addNewLecturer: "Add New Lecturer",
        lecturer: "Dozent",
        measure: "Course",
        certificates: "Certificates"
    },
    resultsSheet: {
        applicationForProfessionalDevelopmentFundingResultsSheet: "Application for Professional Development Funding - Results Sheet / Applicant Profile",
        participant: "Participant",
        skillsKnowledgeAbilities: "Skills, Knowledge and Abilities (primarily within the framework of the measure)",
        skillsKnowledgeAbilitiesNote: "Use this also in the Internet at:",
        skillsKnowledgeAbilitiesNoteText: '"BERUFENET - "Berufsbezeichnung" - Activity - Competencies. Please add to this list when needed on another page! The information also serves the revision of the applicant profile in the job portal."',
        YouCanAlsoMakeTheRevisionDirectlyInTheJobPortal: "You can also make the revision directly in the job portal!",
        YouCanAlsoMakeTheRevisionDirectlyInTheJobPortalNote: "For this you need your access data and write access to your skills, please contact your tutor on this matter.",
        skillsKnowledgeAbilitiesAttention: "Skills, Knowledge and Abilities Attention!!!",
        skillsKnowledgeAbilitiesAttentionNote: "Entries for vocational education, apprenticeship and firearms training will automatically be entered as soon as the respective \"test\" is created under participant data!",
        itSkills: "IT Skills",
        itSkillsNote: "(e.g. Office-, Graphic programs, industry software, programming)",
        languageSkills: "Language Skills",
        mobility: "Mobility",
        mobilityNote: "(after end of measure)",
        internship: "Practical training",
        internshipNote: "(only fill in with measures with practical training)",
        mobilityReadiness: "Mobility readiness",
        internshipDuringMeasure: "Practical training during the measure",
        employmentBehavior: "Employment behavior",
        jobApplicationActivitiesDuringTheMeasure: "Job application activities during the measure",
        possiblyAttachmentInListForm: "(possible attachment in list form)",
        futureJobApplicationActivities: "Future job application activities extend to the following occupations / activities",
        futureJobApplicationActivitiesNote: "(With your access data for the job portal, you can also enter this directly in a new job application!)",
        alternativesIndustryTemporary: "Alternatives (e.g. industry, temporary work, self-employment)",
        otherNotes: "Other notes",
        otherNotesNote: "(e.g. additional information, collected during the measure)",
        participantSignature: "Participant signature"
    },
    learningProgress: {
        learningProgress: "Learning Progress",
        subjectKnowledge32a: "Subject Knowledge 34a - Video lessons in German",
        courseStarted: "Course started",
        lastVisit: "Last visit",
        certificate: "Certificate",
        title: "Title",
        error: "Error",
        points: "Points",
        firstAidPreparation: "First Aid Preparation (BB)",
        firePrevention: "Fire Prevention & Evacuation Helper according to B10ArbSchG (BB)",
        examinationsAndTests: "Examinations and Tests",
        firearmsPreparation: "Firearms Preparation according to 7 WaffG  (BB)",
        subjectKnowledge: "Subject Knowledge 34a - Exercises for the written exam",
        subjectKnowledge: "Subject Knowledge 34a - Practice examinations"
    },
    traininginsert: {
        trainingInsert: "Insert Training",
        trainingTopic: "Training Topic",
        quarter: "Quarter",
        year: "Year",
        actualDate: "Actual Date",
        participation: "Participation",
        reasonForNonParticipation: "Reasons for Non-Participation",
        feedback: "Feedback / Participation Assessment",
        effectiveness: "Effectiveness",
        registeredTrainings: "Registered Trainings",
        timePeriod: "Time Period",
        planned: "Planned",
        actual: "Actual",
        effectivenessAZAV: "Effectiveness AZAV",
        invoiceStatus: "Invoice Status",
    },
    position: {
        positionTitle: "Position",
        positionTitlePlaceholder: "(e.g., CEO)",
        internalExternal: "Internal / external",
        internal: "internal",
        external: "external",
        responsibilityAndAuthority: "Responsibility and Authority",
        hierarchicalAssignedTo: "Hierarchically assigned to"
    },
    exitreportcreate: {
        exitReportCreate: "Create a discharge report",
        measureEndedByExam: "The measure was ended by early exam / successful participation",
        firstAttendanceDay: "first day of personal attendance",
        lastAttendanceDay: "last day of personal attendance",
        examFailed: "The exam was not passed",
        no: "No",
        create: "Create"
    },
    withdrawalreportcreate: {
        withdrawalReportCreate: "Create a termination report",
        participationTerminated: "Participation in the measure was terminated",
        firstAttendanceDay: "first day of personal attendance",
        lastAttendanceDay: "last day of personal attendance",
        terminationReason: "The measure was terminated due to:",
        employment: "Employment",
        employmentFrom: "Employment from:",
        insufficientPerformance: "Insufficient performance",
        longAbsences: "Longer periods of absence",
        otherReasons: "Other reasons",
        reasons: "Reasons",
        no: "No",
        create: "Create"
    },
    carrier_documents: {
        documents: "Documents",
        feedbackEvaluations: "Created Feedback Form Evaluations",
        date: "Date",
        description: "Description",
        downloadFile: "Download File",
        feedbackDescription: "Feedback Evaluation 01.01.2024 - 06.06.2024",
        successStatistics: "Created Success and Placement Statistics - Evaluations",
        successDescription: "Success Statistics 2024 - 955/234/2023",
        qualificationPlans: "Created Qualification Plans",
        qualificationDescription: "Qualification Plan 2024 -2024",
        organizationChart: "Created Organization Chart",
        qualificationsMatrix: "Created Qualification Matrix",
        qualificationsMatrixDescription: "Qualification Matrix",
        trainingReports: "Training Reports per Lecturer",
        noData: "-"
    },
    liveattendance: {
        updateValues: "Update Values",
        importantNote: "Important Note",
        importantNoteText: "The display only shows the logins in our Lenportal! At the moment we unfortunately cannot display the attendance in the Zoom rooms.",
        attendanceList: "Attendance List",
        stampSet: "The stamp has been set",
        TNWillAbbrechenStatus: "TN will abbrechen Status :",
        NoLoginAttemptInTheMorning: "No login attempt in the morning",
        NoLoginAttemptInTheAfternoon: "No login attempt in the afternoon",
        WillBeDisplayedFrom100PM: "Will be displayed from 13:00 o'clock",
        LastLoginAt: "Last login at 09:41 o'clock",
    },
    missingSignatures: {
        missingSignatures: "Missing Signatures",
        missingSignaturesList: "Missing Signatures List",
        missingSignaturesText: "Missing Signatures for 4 days :",
        updatedOn: "Updated On",
        carrier: "Carrier",
        intermediary: "Intermediary"
    },
    days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday"
    },
    vocationalTraining: {
        questionnaireForParticipantsInVocationalTrainingPrograms: "Questionnaire for participants in vocational training programs",
        vocationalTraining: "You are currently taking part in a vocational training measure. For the Federal Employment Agency it is important to know what experiences you have made with this measure. Your statements can further help to improve the quality of vocational training.",
        youWillBeAskedToEvaluateTheTrainingProgram: "Below you will be asked to evaluate the vocational training measure you have attended.",
        privacy: "Your statements will be evaluated anonymously (without names);",
        privacyNote: "No conclusions can be drawn about you, so you will not suffer any disadvantages as a result of your statements.",
        note: "If you click on the smiley or answer option, your answer will be saved immediately and will no longer appear in the list!",
        programTitle: "measure title",
        providerTitle: "Provider",
        numberTitle: "measure number",
        status: "There are still 21 of 21 questions to answer!",
        q1: "The existing facilities (classrooms and workrooms, workshops, break rooms, sanitary facilities) are in good condition.",
        q2: "A sufficient technical equipment (PC, machines, tools) is available.",
        q3: "Teaching and learning materials (e.g. workwear, books, scripts, worksheets) are available.",
        q4: "The trainers/instructors explain the course contents in a clear manner.",
        q5: "The trainers/instructors engage with the participants and support them.",
        q6: "The trainers/instructors provide feedback on the individual performance level.",
        q7: "Staff of the training institution supports the participants with personal difficulties.",
        q8: "Staff of the training institution supports the participants in finding an appropriate job.",
        q9: "Before the start of the course, a sufficient information about the contents and (time) schedule was provided.",
        q10: "The training institution has entered into a training contract with me, which contains essential information about the qualification (e.g. qualification contents, practical hours, information about learning materials and workwear, termination and cancellation modalities).",
        q11: "The participants of the course fit well in terms of vocational education and training or prior knowledge.",
        q12: "The course contents / taught subject matter corresponds to my prior knowledge and expectations.",
        q13: "The subject matter is explained in a clear manner.",
        q14: "The course is so designed that I have enough time to process and consolidate what I have learned.",
        q15: "The course is well organized (e.g. in terms of timely and comprehensive provision of lesson plans, break regulations, practice opportunities).",
        q16: "In the course, different media are used (e.g. flip chart, lesson plans, projector, films, interactive media).",
        q17: "Regular performance controls are held (e.g. classwork, tests, practical tasks).",
        q18: "In case of absence of trainers/instructors, a substitute is guaranteed.",
        q19: "Which of the following statements best fits your opinion when evaluating the qualification measures?",
        q20: "The duration of the qualification measure is, in my current assessment, overall ...",
        q21: "Overall, I am satisfied or dissatisfied with the qualification measure?",
        satisfied: "Satisfied",
        notSatisfied: "Not satisfied",
        neutral: "Neutral",
        questions: "Questions",
        justRight: "just right",
        tooShort: "too short",
        partial: "partial",
        tooLong: "too long",
        canSayYet: "I can't say yet",
        helpful: "The training helps me to find a job more easily",
        unchanged: "My chances of getting a job have not changed",
        worse: "I just lost time, and my chances of getting a job have worsened",
        unknown: "I cannot yet say whether something has changed",
        noteAndRemark: "Notes and remarks",
        noteAndRemarkNote: "If you have any additional remarks or notes for the visited qualification measure, you can describe them below:"
    },
    trainingReports: {
        addTrainingReport: "Add Training Report",
        updateTrainingReport: "Update Training Report",
        addNewTrainingReport: "Add New Training Report",
        trainingReport: "Training Report",
        nr: "Nr.",
        trainingTitle: "Training Title",
        trainingDescription: "Training Description",
        ue: "UE",
        signature: "Signature",
        pdfCreated: "PDF created",
        createdTrainingPDFs: "Created training PDFs",
        courseDate: "Course Date",
    },
    form: form
};